import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

import icon1 from "../../../../../../../assets/images/quality/section-3/reducao-custos.svg";
import icon2 from "../../../../../../../assets/images/homepage/section-5/reserva-salas-reunioes.svg";
import icon3 from "../../../../../../../assets/images/consulting/section-2/outsourcing.svg";
import icon4 from "../../../../../../../assets/images/homepage/section-5/gestao-creditos.svg";
import icon5 from "../../../../../../../assets/images/quality/section-3/vantagem-competitiva.svg";

const OutsourcingVsFull4 = props => (
    <section id="outsourcing-vs-full-section4" className="my pt-5">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingVsFull:section-4.title')}</h2>
            {/* Sub-item 1 */}
            <div className='d-flex align-items-center mb-4'>
                {/* Icon */}
                <div className='icon-container d-none d-md-block'>
                    <div className="diamond-top-icon">
                        <div className="icon">
                            <img alt={props.alt} src={icon1} />
                        </div>
                    </div>
                </div>
                {/* Text */}
                <div>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingVsFull:section-4.1.title')}</h3>
                    <p>
                        <Trans
                            i18nKey="services:outsourcingVsFull:section-4.1.text"
                            components={{
                                br: <br />,
                                outsourcingCost: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_cost.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            </div>
            {/* Sub-item 2 */}
            <div className='d-flex align-items-center mb-4'>
                {/* Icon */}
                <div className='icon-container d-none d-md-block'>
                    <div className="diamond-top-icon">
                        <div className="icon">
                            <img alt={props.alt} src={icon2} />
                        </div>
                    </div>
                </div>
                {/* Text */}
                <div>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingVsFull:section-4.2.title')}</h3>
                    <p>
                        <Trans
                            i18nKey="services:outsourcingVsFull:section-4.2.text"
                            components={{
                                br: <br />,
                                outsourcingAdvantages: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_advantages.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            </div>
            {/* Sub-item 3 */}
            <div className='d-flex align-items-center mb-4'>
                {/* Icon */}
                <div className='icon-container d-none d-md-block'>
                    <div className="diamond-top-icon">
                        <div className="icon">
                            <img alt={props.alt} src={icon3} />
                        </div>
                    </div>
                </div>
                {/* Text */}
                <div>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingVsFull:section-4.3.title')}</h3>
                    <p>
                        <Trans
                            i18nKey="services:outsourcingVsFull:section-4.3.text"
                            components={{
                                br: <br />,
                                outsourcingPilar: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_pilar.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            </div>
            {/* Sub-item 4 */}
            <div className='d-flex align-items-center mb-4'>
                {/* Icon */}
                <div className='icon-container d-none d-md-block'>
                    <div className="diamond-top-icon">
                        <div className="icon">
                            <img alt={props.alt} src={icon4} />
                        </div>
                    </div>
                </div>
                {/* Text */}
                <div>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingVsFull:section-4.4.title')}</h3>
                    <p>
                        <Trans
                            i18nKey="services:outsourcingVsFull:section-4.4.text"
                            components={{
                                br: <br />
                            }}
                        />
                    </p>
                </div>
            </div>
            {/* Sub-item 5 */}
            <div className='d-flex align-items-center mb-4'>
                {/* Icon */}
                <div className='icon-container d-none d-md-block'>
                    <div className="diamond-top-icon">
                        <div className="icon">
                            <img alt={props.alt} src={icon5} />
                        </div>
                    </div>
                </div>
                {/* Text */}
                <div>
                    <h3 className='h6 fw-600 light-orange'>{props.t('services:outsourcingVsFull:section-4.5.title')}</h3>
                    <p>
                        <Trans
                            i18nKey="services:outsourcingVsFull:section-4.5.text"
                            components={{
                                br: <br />
                            }}
                        />
                    </p>
                </div>
            </div>
        </Container>
    </section>
);

export default OutsourcingVsFull4;
